export default __webpack_public_path__ + "static/media/MO.9ef2ce6f.svg";